import { adminHttpClient } from '../commons/adminHttpClient'

export interface BenefitUsageOverviewResponse {
  totalAllowance?: number
  totalReimbursed?: number
  reimbursementsDue?: number
  totalAllowanceRemaining?: number
  monthlyAllowance?: number
}

const getBenefitUsageOverview = (planPeriodId?: string): Promise<BenefitUsageOverviewResponse> => {
  return adminHttpClient.get(`/Benefit/EmployeeBenefitUsageOverview/${planPeriodId}`)
}

export default getBenefitUsageOverview
